import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import { ReactNode } from 'react';

interface Props {
    title: string;
    /** 기간 앞에 붙는 뱃지 (이벤트 상태 등) */
    badge?: ReactNode;
    startAt?: Date;
    endAt?: Date;
}

/** 새소식 상세(이벤트·공지사항) 상단: 제목 / 뱃지·기간 / 구분선 */
function BoardDetailHeader({
    title, badge, startAt, endAt,
}: Props) {
    const hasPeriod = !!startAt && !!endAt;
    return (
        <Container as='section'
            fullWidth
            spacing={4}>
            <Title size='headline' fontWeight='bold' color={colors.textPrimary}>
                {title}
            </Title>
            {(badge || hasPeriod) && (
                <Row spacing={2}>
                    {badge}
                    {hasPeriod && (
                        <Text color={colors.textSecondary}>
                            {dayjs(startAt).format('YYYY.MM.DD')} ~ {dayjs(endAt).format('YYYY.MM.DD')}
                        </Text>
                    )}
                </Row>
            )}
            <Divider isThin />
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

const Title = styled(Text)`
    white-space: wrap;
    word-break: break-word;
    width: 100%;
`;

export default BoardDetailHeader;
